import { Controller } from "@hotwired/stimulus";

// use this to rename a click or event from another controller
export default class extends Controller {
  static values = { name: String, onLoad: Boolean }

  connect() {
    if (this.onLoadValue) {
      this.rename()
    }
  }

  rename(e) {
    const detail = e.detail ? e.detail : {};
    const params = e.params ? e.params : {};
    this.dispatch(this.nameValue, {
      detail: { renamed: true, target: e.target, ...params, ...detail },
      prefix: false
    })
  }
}
